<!-- <nb-card>
  <nb-card-header>Cargar comprobante</nb-card-header>
  <nb-card-body>
    <div class="row">
      <div class="col-12">
        <dynamic-form *ngIf="formComprobante" [fields]="formComprobante" header="<b>Seleccionar cliente</b>"
          (submit)="dismiss()">
        </dynamic-form>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button class="btn btn-primary float-right" (click)="dismiss()">Guardar comprobante</button>
  </nb-card-footer>
</nb-card> -->


<div class="row">
  <div class="col-12">
    <dynamic-form *ngIf="formComprobante" [fields]="formComprobante"
      (submit)="guardarComprobante($event)">
    </dynamic-form>
  </div>
</div>
<!-- <nb-card>
  <nb-card-header>Cargar comprobante</nb-card-header>
  <nb-card-body>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras convallis tincidunt tincidunt.
    Vestibulum vulputate maximus massa vel tristique. Suspendisse potenti. Duis aliquet purus sed dictum dictum.
    Donec fringilla, purus at fermentum imperdiet, velit enim malesuada turpis, quis luctus arcu arcu nec orci.
    Duis eu mattis felis. Quisque sollicitudin elementum nunc vel tincidunt. Vestibulum egestas mi nec
    iaculis varius. Morbi in risus sed sapien ultricies feugiat. Quisque pulvinar mattis purus,
    in aliquet massa aliquet et.
  </nb-card-body>
  <nb-card-footer>
    <button class="btn btn-primary float-right" (click)="dismiss()">Guardar comprobante</button>
  </nb-card-footer>
</nb-card> -->